module.exports = __webpack_public_path__ + "img/o.2b3ba734.jpg";